<template>
    <div class='ba-box-search-input ba-sm'>
        <input type='search' class='ba-input' :placeholder="$t('ct-search')" aria-label="Search" v-model="config.search"
            ref="inputSearch" @input="isTyping = true" @keyup="clearSearch" />
        <button class='ba-button'>
            <builderall-icon code='search' />
        </button>
    </div>
</template>

<script>

const debounce = (callback, wait) => {
    let timeout;
    return (...args) => {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => callback.apply(context, args), wait);
    };
};
export default {
    name: 'SearchInput',
  props: ['config'],

    data() {
        return {
            isTyping: false,
            isLoading: false,
        };
    },
    watch: {
        isTyping: function (value) {
            if (!value) {
                this.searchWebsites();
            }
        }
    },
    methods: {
        searchWebsites: function () {
            this.isLoading = true;
            this.search();
        },
        async search() {
            if (this.isLoading) {
                await this.$emit('search');
                this.isLoading = false;
            }
        },
        reset() {
            this.config.search = '';
            this.isLoading = true;
            this.search();
        },

        clearSearch() {
            if (this.config.search === '') this.isLoading = true;
        },
    },
    mounted() {
        var vm = this;
        this.$refs.inputSearch.addEventListener('keyup', debounce(() => {
            vm.isTyping = false;
        }, 500));
    }
};
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/components/general/SearchInput.vue